import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Wrapper = styled('div')`
  position: relative;
  z-index: 1;
  > svg {
    display: block;
  }
`;

interface DataTableWrapperProps {
  x: number;
  flip: boolean;
  width: number;
}

export const DataTableWrapper = styled('div')<DataTableWrapperProps>`
  background: ${({ theme }) => theme.color.black};
  padding: ${({ theme }) => theme.x1spacePx}px;
  ${({ theme }) =>
    theme.appTheme === 'light' &&
    `border: 1px solid ${theme.color.whiteRGBA(0.2)};`}
  margin: 0 8px;
  ${media.mdUp`
    margin: 0;
    max-width: ${({ width }) => width}px;
    transform: ${({ x, width, flip }) =>
      `translateX(${x - (flip ? width - 1 : 0)}px)`};
  `}
`;

interface NowProps {
  hover: boolean;
}

export const Now = styled('rect')<NowProps>`
  opacity: ${({ hover }) => (hover ? 1 : 0.3)};
  transition: opacity 0.3s;
`;
